import { createFileRoute } from '@tanstack/react-router';

import { OauthConsentPage } from '@/features/oauth-consent/components/oauth-consent-page';

const CONSENT_REQUEST_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const Route = createFileRoute('/oauth/consent')({
    validateSearch: (search: Record<string, unknown>) => {
        const request = typeof search.request === 'string' ? search.request.trim() : '';

        return {
            request: CONSENT_REQUEST_ID_PATTERN.test(request) ? request : ''
        };
    },
    component: OauthConsentRouteComponent
});

function OauthConsentRouteComponent() {
    const { request } = Route.useSearch();

    return <OauthConsentPage consentRequestId={request} />;
}
